const CLIENT_ID_KEY = 'ft.ft3d.move-preview.client-id.v1';
const SEQUENCE_KEY = 'ft.ft3d.move-preview.sequence.v1';
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

let memoryClientId = '';
let memorySequence = 0;

function previewSessionStorage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function createClientId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Stable for one top-level browser tab and its same-origin frames. A different tab, even for the
 * same authenticated user, gets a different id and therefore remains a legitimate observer.
 */
export function ft3dMovePreviewClientId(): string {
  const storage = previewSessionStorage();
  const stored = storage?.getItem(CLIENT_ID_KEY) ?? '';
  if (UUID_PATTERN.test(stored)) {
    memoryClientId = stored.toLowerCase();
    return memoryClientId;
  }
  if (!UUID_PATTERN.test(memoryClientId)) memoryClientId = createClientId().toLowerCase();
  try {
    storage?.setItem(CLIENT_ID_KEY, memoryClientId);
  } catch { /* memory fallback remains valid for this document */ }
  return memoryClientId;
}

/** One sequence shared by the tab and its same-origin frames, so every movement lane orders together. */
export function nextFt3dMovePreviewSequence(): number {
  const storage = previewSessionStorage();
  const stored = Number.parseInt(storage?.getItem(SEQUENCE_KEY) ?? '', 10);
  memorySequence = Math.max(memorySequence, Number.isSafeInteger(stored) && stored >= 0 ? stored : 0) + 1;
  try {
    storage?.setItem(SEQUENCE_KEY, String(memorySequence));
  } catch { /* memory fallback remains monotonic for this document */ }
  return memorySequence;
}

export function isLocalFt3dMovePreviewClient(value: unknown): boolean {
  const candidate = String(value ?? '').trim().toLowerCase();
  return UUID_PATTERN.test(candidate) && candidate === ft3dMovePreviewClientId();
}

export function isFt3dMovePreviewClientId(value: unknown): boolean {
  return UUID_PATTERN.test(String(value ?? '').trim());
}
